import * as R from 'ramda';
import { toastr } from 'react-redux-toastr';
// constants/helpers
import * as GC from '../constants';
import { ENUMS } from '../constants/enums';
import { getWindowLocale } from './locale';
import { getAmousConfigByNameFromWindow } from './window';
//////////////////////////////////////////////////

// use with sagas
function* showToastrMessage(type, message, toastrOptions = {}) {
  const msg = getWindowLocale(message, message);

  toastr[type](msg, toastrOptions);
}

// use with wait/async
const showToastrMessageSimple = (type, message, toastrOptions = {}) => (
  toastr[type](message, toastrOptions)
);

const showToastrMessageSimpleSuccessDefault = () => (
  showToastrMessageSimple(
    'success',
    getWindowLocale('messages:success:200-201', 'The request has succeeded'),
  )
);

const showToastrMessageSimpleCatchDefault = () => (
  showToastrMessageSimple(
    'error',
    getWindowLocale(
      'messages:error:unknown',
      'Oops! The system is experiencing a problem. The issue has been reported.',
    ),
  )
);

const showToastrMessageFromLocale = (type, localeKey) => (
  toastr[type](getWindowLocale(localeKey))
);

const topLeftPlacement = R.prop(ENUMS.ENUM_TOP_LEFT, GC.UI_MESSAGE_PLACEMENT_MAP);

const getToastrMessagePlacement = () => {
  const value = getAmousConfigByNameFromWindow(GC.UI_API_MESSAGE_PLACEMENT);

  return R.propOr(topLeftPlacement, value, GC.UI_MESSAGE_PLACEMENT_MAP);
};

export {
  showToastrMessage,
  showToastrMessageSimple,
  getToastrMessagePlacement,
  showToastrMessageFromLocale,
  showToastrMessageSimpleCatchDefault,
  showToastrMessageSimpleSuccessDefault,
};
